import React from "react";
import { Grid } from "@mui/material";
import Link from "next/link";
import { getAssets } from "@unisearch/helpers";
import { IoIosArrowForward } from "react-icons/io";
import styles from "./ensure_quality.module.scss";

const state = [
  {
    id: 1,
    item: "Student Profiles",
  },
  {
    id: 2,
    item: "Profile Matching",
  },
  {
    id: 3,
    item: "UniSearch Dashboard",
  },
  {
    id: 4,
    item: "Expert Counsellors",
  },
  {
    id: 5,
    item: "Conversations",
  },
];

export const UniPageQualityEnsure = () => {
  return (
    <section>
      <div className="container">
        <Grid container spacing={4} alignItems="center">
          <Grid item md={6} xs={12} className={styles.ensure_quality}>
            <h2>How We Ensure Quality</h2>
            <p>
              Out of over 1 million visitors, how do we make sure only the best
              candidates connect with your university?
            </p>
            <div className={styles.list_group}>
              {state.map((item) => (
                <div key={item.id} className={styles.item_group}>
                  <IoIosArrowForward className={styles.icon} />
                  <p>{item.item}</p>
                </div>
              ))}
            </div>

            <Link legacyBehavior href="/university/booking">
              <a className="btn btn-bg btn-secondary">Learn More</a>
            </Link>
          </Grid>
          <Grid item md={6} xs={12}>
            <img
              src={getAssets("assets/images/unipage/quality_ensure.png")}
              alt="Quality Ensure"
              width="100%"
            />
          </Grid>
        </Grid>
      </div>
    </section>
  );
};

export default UniPageQualityEnsure;
